"use client"

/**
 * Provides shallow routing (url change without router change) helpers.
 * next.js has experimental support for next router + window history, see https://github.com/vercel/next.js/pull/58335
 */
export const useShallowRouting = () => {
  const push = (url: string) => {
    window.history.pushState(null, "", url)
  }

  const replace = (url: string) => {
    window.history.replaceState(null, "", url)
  }

  return {
    push,
    replace,
  }
}
